import dynamic from 'next/dynamic'
import Result from 'components/Result'
import { useUserProfileQuery } from 'graphql/types'
import { IconPerson } from 'icons'
import useMap from './useMap'

const LoginModal = dynamic(() => import('components/LoginModal'))

const useLogin = () => {
  const { data } = useUserProfileQuery({
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  })
  const [loginModal, { setAll: setLoginModal }] = useMap({
    isMounted: false,
    isVisible: false,
  })

  const isAuthenticated = !!data?.userProfile

  const Login = () => (
    <>
      {loginModal.isMounted && (
        <LoginModal
          isModalVisible={loginModal.isVisible}
          onClose={() => setLoginModal({ isMounted: true, isVisible: false })}
        />
      )}
      {!isAuthenticated && (
        <Result
          Icon={{
            Component: IconPerson,
            color: 'grey900',
            title: 'Ícone: Usuário',
          }}
          title="Entrar na minha conta"
          text="Para exibir esse conteúdo precisamos saber quem é você."
          buttons={[
            {
              label: 'Entrar',
              props: {
                theme: 'pink',
                onClick: () =>
                  setLoginModal({ isMounted: true, isVisible: true }),
              },
            },
          ]}
        />
      )}
    </>
  )

  return { isAuthenticated, Login, userProfile: data?.userProfile }
}

export default useLogin
